import { useCallback, useEffect, useMemo, useState } from 'react'
import { selectCollapsedByUser, useSidebarPreferenceStore } from '../store/ui/sidebarPreference'

export interface UseSidebarCollapsedResult {
    collapsed: boolean
    setCollapsed: (collapsed: boolean) => void
    hydrated: boolean
}

export const useSidebarCollapsed = (userId?: string | null): UseSidebarCollapsedResult => {
    const hydrate = useSidebarPreferenceStore((state) => state.hydrate)
    const storeSetCollapsed = useSidebarPreferenceStore((state) => state.setCollapsed)
    const selector = useMemo(() => selectCollapsedByUser(userId), [userId])
    const collapsed = useSidebarPreferenceStore(selector)
    const [hydrated, setHydrated] = useState(false)
    const [localCollapsed, setLocalCollapsed] = useState(false)

    useEffect(() => {
        if (!userId) {
            setHydrated(true)
            return
        }

        hydrate(userId)
        setHydrated(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hydrate, userId])

    const setCollapsed = useCallback(
        (next: boolean) => {
            if (!userId) {
                setLocalCollapsed(next)
                return
            }
            storeSetCollapsed(userId, next)
        },
        [storeSetCollapsed, userId]
    )

    return {
        collapsed: userId ? collapsed : localCollapsed,
        setCollapsed,
        hydrated,
    }
}
